import React from 'react';
import styles from '../RateView.module.css';

import FilterLabel from './FilterLabel';
import { getCurrentResource, validDateTime } from '../../../util/tools';

class FilterDateTimeDiapason extends React.Component {

	constructor(props) {
		super(props);
		this.resource = getCurrentResource().components.rateview.filter.FilterDateTimeDiapason;
		let filter = props.filter;
		this.filterValue = {
			fromAsString: filter.initialValue,
			toAsString: filter.initialValue2,
		};
		this.state = {
			dirtyCount: 0, 
			fromValue: this.filterValue.fromAsString, 
			toValue: this.filterValue.toAsString 
		};
		if( this.filterValue.fromAsNumber || this.filterValue.toAsNumber )
			this.updateQuery();
	}
	componentDidMount() {
		let rateView = this.props.rateView;
		rateView.registerFilter( this );
	}
	componentWillUnmount() {
		let rateView = this.props.rateView;
		rateView.unregisterFilter( this );
	}
	
	clearFilter() {
		this.props.rateView.clearQueryFilter( this.props.filter.predicateId )
		this.filterValue = {
			fromAsString: '', 
			toAsString: '',
		}
		this.setState({
			dirtyCount: this.state.dirtyCount+1,
			fromValue: '', 
			toValue: '' 
		});
	}
	handleValueChange = (e) => {
		this.props.rateView.clearData();
		const {name, value} = e.target;
		let valid = validDateTime( value );
		if( name == 'dateFrom' ) {
			this.filterValue.fromAsString = valid ? value : '';
		} else if( name == 'dateTo' ) {
			this.filterValue.toAsString = valid ? value : '';
		}

		if( ! this.filterValue.fromAsString && ! this.filterValue.fromAsString ) {
			this.props.rateView.clearQueryFilter( this.props.filter.predicateId )
		} else {
			this.updateQuery();
		}

		if( name == 'dateFrom' ) {
			this.setState({fromValue: value});
		} else if( name == 'dateTo' ) {
			this.setState({toValue: value});
		}
	}
	
	updateQuery = () => {
		let q = this.props.rateView.query;
		let indexFilter = -1;
		for(let i=0; i < q.listPredicate.length; i++) {
			if( q.listPredicate[i].predicateId == this.props.filter.predicateId ) {
				indexFilter = i;
				break;
			}
		}
		if( indexFilter < 0 ) {
			q.listPredicate.push( {
				predicateId: this.props.filter.predicateId,
				conditionId: this.props.filter.conditionId,
				fromAsString: this.filterValue.fromAsString,
				toAsString: this.filterValue.toAsString,
			} );
		} else {
			q.listPredicate[indexFilter].fromAsString = this.filterValue.fromAsString;
			q.listPredicate[indexFilter].toAsString = this.filterValue.toAsString;
		}
	}

	fetchProfile = () => {
		if( this.filterValue.fromAsString || this.filterValue.toAsString )
			return {
				filterId: this.props.filter.predicateId, 
				fromAsString: this.filterValue.fromAsString,
				toAsString: this.filterValue.toAsString,
			};
		else
			return null;
	}
	applyProfile = (profile) => {
		this.filterValue.fromAsString = profile.fromAsString;
		this.filterValue.toAsString = profile.toAsString;
		this.updateQuery();
		this.setState({
			dirtyCount: this.state.dirtyCount+1,
			fromValue: this.filterValue.fromAsString, 
			toValue: this.filterValue.toAsString 
		});
	}

	render() {
		let filter = this.props.filter;
		let bgFrom = validDateTime( this.state.fromValue ) ? 'White' : 'LightYellow';
		let bgTo = validDateTime( this.state.toValue ) ? 'White' : 'LightYellow';
		return (
			<div className={styles.divFilter}>
				<FilterLabel title={filter.title} tooltip={filter.tooltip} />
				<div className={styles.divFilterInput} style={{display: 'flex'}}>
					<input type='text' name='dateFrom' value={this.state.fromValue} 
						onChange={this.handleValueChange} placeholder={this.resource.placeholder}
						style={{backgroundColor: bgFrom, width: '100px', flexGrow: '1'}}
						title={this.resource.tooltip}
					/>
					<div style={{margin: '0 5px 0 5px'}}>-</div>
					<input type='text' name='dateTo' value={this.state.toValue} 
						onChange={this.handleValueChange} placeholder={this.resource.placeholder}
						style={{backgroundColor: bgTo, width: '100px', flexGrow: '1'}}
						title={this.resource.tooltip}
					/>
				</div>
			</div>
		);
	}	
}

export default FilterDateTimeDiapason;
